import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FiGlobe, FiFileText, FiMail } from 'react-icons/fi';
import Overview from './Overview';
import WebsiteContent from './WebsiteContent';
import NewsMedia from './content/NewsMedia';
import AddNews from './content/AddNews';
import BoardManagement from './content/BoardManagement';
import AddPerson from './content/AddPerson';
import Governance from './content/Governance';
import OtherDocuments from './content/OtherDocuments';
import CompanyDetails from './content/CompanyDetails';
import CapitalStructure from './content/CapitalStructure';
import ContactForms from './contact/ContactForms';
import ContactMessage from './contact/ContactMessage';
import FormSettings from './contact/FormSettings';
import { NEW_MESSAGES } from './hubData';

// Website Hub (spec page 449:7). /website-hub = Overview, /website-hub/content[/section[/add]], /website-hub/contact-forms[/message/{id} | /settings[/tab]].
// Preview only: nothing reads WordPress, analytics or a message store yet.
const tabs = [
    { path: '', label: 'Overview', icon: <FiGlobe /> },
    { path: 'content', label: 'Website Content', icon: <FiFileText /> },
    { path: 'contact-forms', label: 'Contact Forms', icon: <FiMail />, badge: NEW_MESSAGES },
];

// the Website content sections: url segment → list page, and its add / edit page (the add pages have no tab row, as in the spec)
const SECTIONS: Record<string, { page: React.FC; add?: React.FC }> = {
    'news-media': { page: NewsMedia, add: AddNews },
    'board-management': { page: BoardManagement, add: AddPerson },
    'corporate-governance': { page: Governance },
    'other-documents': { page: OtherDocuments },
    'company-details': { page: CompanyDetails },
    'capital-structure': { page: CapitalStructure },
};

const WebsiteHub: React.FC = () => {
    const history = useHistory();
    const { tab = '', section = '', id = '' } = useParams<{ tab?: string; section?: string; id?: string }>();
    const current = tabs.find(x => x.path === tab) ?? tabs[0];

    let body: React.ReactNode;
    let showTabs = true;
    if (current.path === 'content') {
        const s = SECTIONS[section];
        if (s && (id === 'add' || id === 'edit') && s.add) {
            showTabs = false;
            // keyed on add / edit only, so switching the ?type= tile keeps what was typed
            body = <s.add key={id} />;
        }
        else body = s ? <s.page /> : <WebsiteContent />;
    }
    else if (current.path === 'contact-forms') {
        if (section === 'message' && id) body = <ContactMessage id={id} />;
        else if (section === 'settings') body = <FormSettings tab={id} />;
        else body = <ContactForms />;
    }
    else body = <Overview />;

    // the client-settings classes give the hub the same cards, fields, toggles and modal shell (SettingsModal)
    return <div className="v2-page account-v2 client-settings-v2 website-hub-v2">
        {showTabs && <div className="sub-tabs">
            {tabs.map(x => <button key={x.path} type="button" className={x === current ? 'active' : ''}
                onClick={() => history.push(`/website-hub${x.path && `/${x.path}`}`)}>
                {x.icon} {x.label}{x.badge ? <span className="badge">{x.badge}</span> : null}
            </button>)}
        </div>}
        {body}
    </div>;
};

export default WebsiteHub;
